import { create as t } from "zustand";
const p = () => {
  const r = navigator.userAgent;
  return /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(r) ? "tablet" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(r) ? "mobile" : "desktop";
}, s = (r, n = !1) => t((i) => ({
  ...r || {},
  isOpen: n,
  toggle: () => i((e) => ({ ...e, isOpen: !e.isOpen })),
  close: () => i((e) => ({
    ...e,
    ...r,
    isOpen: !1
  })),
  closeWithoutReset: () => i((e) => ({
    ...e,
    isOpen: !1
  })),
  open: (e) => i((o) => e ? {
    ...o,
    ...e,
    isOpen: !0
  } : { ...o, isOpen: !0 })
}));
export {
  s as createModalStore,
  p as getDeviceType
};
